<template>
  <div class="tableWithPerPageSelection section-details">
    <a ref="lienDownload"></a>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div v-if="!isSelectable" class="column is-narrow">
            <selecteur-action
              @handleAction="manageActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="facesSelectionnees">
            </selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-narrow pdr-0">
            <b-input :placeholder="$t('listeFace.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{$t('listeProduitNonCom.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <b-field v-if="!isSelectable" class="column mg-0">
          <b-checkbox-button
              v-model="withoutImage"
              type="is-primary"
              outlined
              @input="recherche">
              <b-icon
                :icon="withoutImage ? 'image-off-outline' : 'image-outline'"
                class="mg-0">
              </b-icon>
          </b-checkbox-button>
        </b-field>
        <div v-if="!isSelectable" class="column is-narrow">
          <exportExcelButton
              :perm="permEmplacement.exporter"
              :query="exportExcelQuery"
              :secondaryExports="secondaryActions"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="selected" class="has-text-centered" slot-scope="props">
        <qd-checkbox v-model="props.row.selected"
                    :value="props.row">
        </qd-checkbox>
      </div>
      <div slot="image" slot-scope="props" class="has-text-centered">
        <image-view
          :permission="permEmplacement"
          :image="props.row.cheminMin"
          :imageTooltip="props.row.chemin"
          :id="props.row.produitId"
          :libelle="props.row.code"
        />
      </div>
      <div slot="addSelection" slot-scope="props">
        <b-tooltip :label="$t(getSelectionButtonMessage(props.row))"
                   :type="getSelectionButtonColor(props.row)">
          <button
            @click="$emit(
              isInSelection(props.row) ? 'removeSelection' : 'addSelection',
              [props.row],
            )"
            class="ripple button width-100percent"
            :class="getSelectionButtonColor(props.row)">
            <b-icon icon="plus-circle"></b-icon>
          </button>
        </b-tooltip>
      </div>
      <div slot="materiel.code" slot-scope="props">
        <router-link-blank :to="{ name: 'c.gabed.emplacement-detailMateriel',
                                  params: { idMateriel: props.row.materiel.id }}"
                           :message="props.row.materiel.code">
        </router-link-blank>
      </div>
      <div slot="code" slot-scope="props">
        <router-link :to="{ name: 'c.gabed.emplacement-face',
                            params: { idFace: props.row.id }}"
                     class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(permEmplacement.lecture)}">
          {{ props.row.code }}
        </router-link>
      </div>
      <div slot="actif" slot-scope="props">
        <div>{{ props.row.actif ? $t('general.non') : $t('general.oui') }}</div>
      </div>
      <div slot="materiel.dispositif.adresse.adresse1" slot-scope="props">
        {{ props.row.materiel.dispositif.adresse | adresse }}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtatMontage(props.row.etat)) }}
      </div>
      <div slot="materiel.format.libelle" slot-scope="props">
        {{ props.row.materiel.format ? props.row.materiel.format.libelle : '' }}
      </div>
      <div slot="materiel.type.libelle" slot-scope="props">
        {{ props.row.materiel.type ? props.row.materiel.type.libelle : '' }}
      </div>
      <div slot="materiel.dispositif.dispositifType.libelle" slot-scope="props">
        {{ props.row.materiel.dispositif && props.row.materiel.dispositif.dispositifType ?
        props.row.materiel.dispositif.dispositifType.libelle : '' }}
      </div>
      <div slot="materiel.dispositif.dispositifSupport.libelle" slot-scope="props">
        {{ props.row.materiel.dispositif && props.row.materiel.dispositif.dispositifSupport ?
        props.row.materiel.dispositif.dispositifSupport.libelle : '' }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.materiel.dispositif.emplacement.agenceId) }}
      </div>
      <div slot="affectation" slot-scope="props">
        <info-affectations v-if="affectations[props.row.produitId] !== undefined"
            :affectations="affectations[props.row.produitId]"
            :row="props.row"
            :faceMotifNonComId="props.row.faceMotifNonComId"
            :isFromLigneFace="false">
        </info-affectations>
      </div>
      <div slot="edit" slot-scope="props">
        <btn-action-icon
          :tooltip-label="$t('general.button.edit')"
          :permission="permEmplacement.maj"
          @is-click="$router.push({ name: 'm.gabed.emplacement-faceEdition',
                    params: { idMateriel: props.row.materiel.id, idFace: props.row.id }})"
          icon-type="is-success"
          icon="pencil-box-outline">
        </btn-action-icon>
      </div>
      <div slot="archiver" slot-scope="props">
        <archive-list-button
          :permissions="permEmplacement.supprimer"
          v-bind="getDataPopupArchivage(props.row)"
          class="has'text-centered"
          @done="recherche()"
          :query="() => archiverFace(props.row)"
          :validation="validationFaceArchivage"
          :actif="props.row.actif"/>
      </div>
      <div slot="delete" slot-scope="props">
        <delete-list-button
          :query="() => deleteFace(props.row.id)"
          :validation="validationDeleteFace"
          :permissions="permEmplacement.supprimer"
          :title="$t('listeFace.titleSupprimer', { code: props.row.code })"
          :successMessage="$t('listeFace.messages.success.faceDeleted', { code: props.row.code })"
          :tooltip-label="$t('general.button.delete')"
          @done="recherche()"/>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-face @toggleFiltre="setShowFiltre" ref="filtreListeFace"
                           :is-selectable="isSelectable"
                           @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="choiceEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import { TYPE_DONNEE_FACE, TYPE_EXPORT_CAFACE } from '@/configuration/gabed/emplacement/emplacementConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import filtreListeFace from '@/components/gabed/face/filtreListeFace';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatIsoDate from '@/services/general/formatIsoDate';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { TYPE_COMMANDE, TYPE_DEVIS } from '@/configuration/devisConf';
import {
  AFFECTATION_RESEAU,
  CATEGORIE_REGROUPEMENT,
  ACTION_DIAPORAMA,
  TYPE_SOURCE_DIAPORAMA,
  TYPE_DONNEE_DIAPORAMA,
  LISTE_CHOICE_EDITION_FACE_PATRIMOINE,
} from '@/configuration/catalogue/produitConf';
import { EPHEMERAL_FACE_STORE, SELECTION_STATE } from '@/configuration/gabed/patrimoine/patrimoineConf';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { deleteFace, archiver } from '@/api/gabed/face/index';
import validationDeleteFace from '@/services/gabed/face/validationDeleteFace';
import infoAffectations from '@/components/general/infoAffectations';
import validationFace from '@/services/gabed/face/validationFace';
import popUpEdition from '@/components/factures/p_edition';
import { columnsSplice } from '@/services/general/columns';
import selecteurAction from '@/components/general/selecteurAction';
import archiveListButton from '@/components/general/button/archiveListButton';
import deleteListButton from '@/components/general/button/deleteListButton';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import edition from '@/api/edition/index';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_FACES } from '@/configuration/general/referenceTableConf';
import BtnActionIcon from '@/components/general/btnActionIcon';
import {
  ACTION_MASS_EDITION,
} from '@/configuration/general/actionsConf';
import {
  getSelectionColor,
  getSelectionMessage,
} from '@/services/gabed/patrimoine/patrimoineSelection';
import imageView from '@/components/general/imageView';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  name: 'l_face',
  props: {
    isSelectable: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
      unsubscribeValue: null,
      showFiltre: false,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      popUpEdition: false,
      choiceEdition: LISTE_CHOICE_EDITION_FACE_PATRIMOINE,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      constantes: {
        TYPE_PDF,
        TYPE_SOURCE_DIAPORAMA,
        TYPE_DONNEE_DIAPORAMA,
        TYPE_EXPORT_CAFACE,
        EPHEMERAL_FACE_STORE,
        SELECTION_STATE,
      },
      deleteFace,
      validationDeleteFace,
      referenceTable: REFERENCE_TABLE_FACES,
      resultPerPage: RESULTS_PER_PAGE,
      withoutImage: true,
    };
  },
  components: {
    BtnActionIcon,
    TableItemsInView,
    filtreListeFace,
    routerLinkBlank,
    infoAffectations,
    selecteurAction,
    popUpEdition,
    archiveListButton,
    parametrageTable,
    imageView,
    exportExcelButton,
    deleteListButton,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      site: 'site',
      user: 'user',
    }),
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    moduleCBADiaporama() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.diaporamaCBA.key);
    },
    storeName() {
      return this.isSelectable ? this.constantes.EPHEMERAL_FACE_STORE : 'face';
    },
    affectations() {
      return this.$store.getters[`${this.storeName}/affectations`];
    },
    faces() {
      return this.$store.getters[`${this.storeName}/items`];
    },
    total() {
      return this.$store.getters[`${this.storeName}/totalCount`];
    },
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE`, value);
      },
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    allInSelection() {
      return this.faces.every(p => this.selection.find(s => s.id === p.id));
    },
    calculCaFace() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.calculCaFace.key);
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'actif', 'proposableReseau', 'proposableLc', 'eclaire', 'avecCoordonnees'];
      if (this.societeActive.agences.length === 1) banCritereKey.push('agencesId');
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      nbCritere += this.criteresRecherche.actif !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.proposableReseau !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.proposableLc !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.eclaire !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.avecCoordonnees !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      const columns = ['addSelection', 'selected', 'image', 'materiel.code', 'code', 'materiel.disposition', 'materiel.format.libelle', 'materiel.type.libelle', 'materiel.dispositif.dispositifType.libelle', 'materiel.dispositif.dispositifSupport.libelle', 'etat', 'materiel.dispositif.adresse.adresse1', 'affectation', 'actif', 'agence', 'edit', 'archiver', 'delete'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      if (this.isSelectable) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'edit');
        columnsSplice(columns, 'archiver');
        columnsSplice(columns, 'delete');
      } else {
        columnsSplice(columns, 'addSelection');
      }
      if (this.withoutImage) columnsSplice(columns, 'image');
      return columns;
    },
    facesSelectionnees() {
      return this.faces.filter((el) => el.selected).length > 0;
    },
    allFaceSelected() {
      return this.faces.filter(e => e.selected).length === this.faces.length;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          'materiel.code': this.$i18n.t('listeFace.tab.codeMateriel'),
          code: this.$i18n.t('listeFace.tab.codeFace'),
          'materiel.disposition': this.$i18n.t('listeFace.tab.disposition'),
          'materiel.format.libelle': this.$i18n.t('listeFace.tab.format'),
          'materiel.type.libelle': this.$i18n.t('listeFace.tab.typeMateriel'),
          'materiel.dispositif.dispositifType.libelle': this.$i18n.t('listeFace.tab.typeDispositif'),
          'materiel.dispositif.dispositifSupport.libelle': this.$i18n.t('listeFace.tab.support'),
          etat: this.$i18n.t('listeFace.tab.etatMontage'),
          'materiel.dispositif.adresse.adresse1': this.$i18n.t('listeFace.tab.adresse'),
          affectation: this.$i18n.t('listeFace.tab.affectation'),
          actif: this.$i18n.t('listeFace.tab.archive'),
          agence: this.$i18n.t('listeFace.tab.agence'),
          edit: '',
          delete: '',
          archiver: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          addSelection: (h) => {
            return h(
              'button', {
                attrs: {
                  class: `ripple button width-100percent ${this.allInSelection ? 'is-success' : 'is-primary'}`,
                },
                on: {
                  click: () => {
                    this.manageAllInSelection();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: 'plus-circle',
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.withoutImage = this.withoutImage;
          if (this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          data.query = cloneDeep(this.criteresRecherche);
          if (data.query.datesMontage) {
            data.query.datesMontage.dateDebut = formatIsoDate(data.query.datesMontage.dateDebut);
            data.query.datesMontage.dateFin = formatIsoDate(data.query.datesMontage.dateFin);
          }
          if (data.query.datesDemontage) {
            data.query.datesDemontage.dateDebut = formatIsoDate(
              data.query.datesDemontage.dateDebut,
            );
            data.query.datesDemontage.dateFin = formatIsoDate(data.query.datesDemontage.dateFin);
          }
          data.query.societeId = this.societeActiveId;
          return this.loadFaces(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.faces,
            count: this.total,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          addSelection: 'colonneSelected',
        },
        sortable: ['materiel.code', 'code', 'materiel.disposition', 'materiel.format.libelle', 'materiel.type.libelle', 'materiel.dispositif.dispositifType.libelle', 'materiel.dispositif.dispositifSupport.libelle', 'etat', 'materiel.dispositif.adresse.adresse1'],
      };
    },
    iconSelectTotal() {
      if (this.allFaceSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    actions() {
      return [
        {
          action: ACTION_DIAPORAMA,
          translation: 'listeFace.actions.editionDiaporama',
          show: this.moduleCBADiaporama,
        },
        {
          action: ACTION_MASS_EDITION,
          translation: 'listeFactures.actions.edition',
          show: true,
        },
      ].filter(el => el.show);
    },
    exportExcelQuery() {
      return {
        typeDonnee: TYPE_DONNEE_FACE,
        TypeExport: null,
        Filtres: this.lastPayload,
      };
    },
    secondaryActions() {
      const actions = [];
      if (this.calculCaFace) {
        actions.push({
          libelle: this.$t('listeFace.actions.exportCA'),
          query: {
            typeDonnee: TYPE_DONNEE_FACE,
            TypeExport: TYPE_EXPORT_CAFACE,
            Filtres: this.lastPayload,
          },
        });
      }
      return actions;
    },
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse);
    },
  },
  methods: {
    loadFaces(data) {
      return this.$store.dispatch(`${this.storeName}/loadFaces`, data);
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    getSelectionState(row) {
      return this.isInSelection(row)
        ? this.constantes.SELECTION_STATE.SELECTED : this.constantes.SELECTION_STATE.UNSELECTED;
    },
    getSelectionButtonColor(selection) {
      return getSelectionColor(this.getSelectionState(selection));
    },
    getSelectionButtonMessage(selection) {
      return getSelectionMessage(this.getSelectionState(selection));
    },
    isInSelection(row) {
      return this.selection.find(f => f.id === row.id);
    },
    manageAllInSelection() {
      if (this.allInSelection) {
        this.$emit('removeSelection', this.faces);
      } else {
        this.$emit('addSelection', this.faces);
      }
    },
    getDataPopupArchivage(face) {
      return {
        title: face.actif
          ? this.$t('listeFace.archivageDesarchiver.archivage')
          : this.$t('listeFace.archivageDesarchiver.desarchivage'),
        messDescription: '',
        successMessage: face.actif
          ? this.$t('listeFace.messages.success.archivage')
          : this.$t('listeFace.messages.success.desarchivage'),
      };
    },
    async archiverFace(face) {
      await archiver(face.id, face.actif);
      face.actif = !face.actif;
      this.recherche();
    },
    validationFaceArchivage(response, messagesPopup) {
      validationFace(response, messagesPopup);
    },
    getInformationDirection(affectation) {
      if (affectation.typeReference === TYPE_COMMANDE) {
        return { routeName: 'c.bodac.commandes', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.typeReference === TYPE_DEVIS) {
        return { routeName: 'c.bodac.devis', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.typeReference === TYPE_COMMANDE) {
        return { routeName: 'c.bodac.commandes', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.sousTypeReference === CATEGORIE_REGROUPEMENT
        && affectation.typeReference === AFFECTATION_RESEAU) {
        return { routeName: 'c.bodac.catalogue-reseau', id: affectation.referenceId, message: affectation.libelle };
      }
      return { routeName: 'c.bodac.catalogue-reseauNumerique', id: affectation.referenceId, message: affectation.libelle };
    },
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeFace.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeFace.initializeFiltre();
      this.$refs.filtreListeFace.viderCritere();
      await this.$refs.filtreListeFace.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    getEtatMontage(codeEtat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
    updateAgenceAndRecherche() {
      this.criteresRecherche.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    selectAll() {
      const select = !this.allFaceSelected;
      this.faces.forEach((el) => { el.selected = select; });
    },
    manageActions(action) {
      switch (action) {
        case ACTION_DIAPORAMA:
          if (this.checkPermissions(this.permEmplacement.editer)) {
            this.editionDiparoma();
          } else this.showPopUp();
          break;
        case ACTION_MASS_EDITION:
          if (this.checkPermissions(this.permEmplacement.editer)) {
            this.errorEdition.messages = [];
            this.errorEdition.haveError = false;
            this.popUpEdition = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFace.errors.noActionSelect'));
          break;
      }
    },
    async edition(donnees, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = id ? [id]
          : this.faces.filter((el) => { return el.selected; }).map(el => el.produitId);
        const response = await edition({
          ids: ids,
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async editionDiparoma() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const allSelection = this.faces.filter((el) => { return el.selected; });
        const response = await edition({
          ids: [allSelection.map(el => el.produitId)[0]],
          extension: this.constantes.TYPE_PDF,
          typeDonnee: this.constantes.TYPE_DONNEE_DIAPORAMA,
          parametresAdditionnels: {
            typeSource: this.constantes.TYPE_SOURCE_DIAPORAMA,
            societeId: this.societeActiveId,
            faceIds: allSelection.map(el => el.produitId).join(';'),
            isCBA: true,
          },
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.faceMotifNonCom]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.calculCaFace.key,
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        PARAMETRES_INTERNE_KEYS.diaporamaCBA.key,
      ]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      this.criteresRecherche.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      if (this.moduleSecteurActive) {
        const targetSecteur = await getSecteursByIds(this.user.secteursId, PATRIMOINE);
        if (targetSecteur.length > 0) {
          this.criteresRecherche.secteurs = targetSecteur.map(ts => ts.id);
        }
      }
      this.criteresRecherche.motifNonCommercialisableIds = this.criteresRecherche
        .motifNonCommercialisableIds.filter((el) => {
          const motifsActifs = this.parametre(PARAMETRES_KEYS.faceMotifNonCom)
            .filter(m => m.actif)
            .map(m => m.id);
          return motifsActifs.includes(el);
        });
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (error) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw error;
    }
  },
};

</script>
